import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as styles from "./styles.css";
export var HeaderVariants;
(function (HeaderVariants) {
    HeaderVariants["headingOne"] = "headingOne";
    HeaderVariants["headingTwo"] = "headingTwo";
    HeaderVariants["headingThree"] = "headingThree";
    HeaderVariants["headingFour"] = "headingFour";
    HeaderVariants["headingFive"] = "headingFive";
    HeaderVariants["headingSix"] = "headingSix";
    HeaderVariants["subHeadOne"] = "subHeadOne";
    HeaderVariants["subHeadTwo"] = "subHeadTwo";
    HeaderVariants["subHeadThree"] = "subHeadThree";
    HeaderVariants["largeTag"] = "largeTag";
    HeaderVariants["smallTag"] = "smallTag";
})(HeaderVariants || (HeaderVariants = {}));
export var Tags;
(function (Tags) {
    Tags["h1"] = "h1";
    Tags["h2"] = "h2";
    Tags["h3"] = "h3";
    Tags["h4"] = "h4";
    Tags["h5"] = "h5";
    Tags["h6"] = "h6";
    Tags["sh1"] = "p";
    Tags["sh2"] = "p";
    Tags["p"] = "p";
    Tags["span"] = "span";
})(Tags || (Tags = {}));
export const Typography = ({ classNameM = M.empty(), variant, children, tag, id, }) => {
    const Component = tag;
    return (React.createElement(Component, { id: id, className: cn(styles.heading, {
            [styles.headingOne]: variant === HeaderVariants.headingOne,
            [styles.headingTwo]: variant === HeaderVariants.headingTwo,
            [styles.headingThree]: variant === HeaderVariants.headingThree,
            [styles.headingFour]: variant === HeaderVariants.headingFour,
            [styles.headingFive]: variant === HeaderVariants.headingFive,
            [styles.headingSix]: variant === HeaderVariants.headingSix,
            [styles.subHeadOne]: variant === HeaderVariants.subHeadOne,
            [styles.subHeadTwo]: variant === HeaderVariants.subHeadTwo,
            [styles.subHeadThree]: variant === HeaderVariants.subHeadThree,
            [styles.largeTag]: variant === HeaderVariants.largeTag,
            [styles.smallTag]: variant === HeaderVariants.smallTag,
        }, classNameM) }, children));
};

